<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  data(){
    return{
      title:'',
      keyWords:'',
      description:``,
      address:'',
      siteID:'',
      siteName:'',
    }
  },

   metaInfo() {
    return {
      title: this.title, // set a title
      meta: [
        {
          // set meta
          name: "keyWords",
          content: this.keyWords,
        },
        {
          name: "description",
          content: this.description,
        },
      ],
    };
  },

  components:{
    // HeadVue,
    // FooterVue,
  },

  mounted() {

  },


};
</script>


<style>

:root {
	--theme-color:#1F2C64;/* 主题色 */
	--theme-color-rgba:31,44,100;/* 主题色rgb */
	--theme-font-color-bg : #E5CD52; /*字体背景颜色*/
	--theme-color-bg:#1F2C64;/* 主题背景色 */
  --theme-color-title:#1F2C64; /*主题标题字体 */
  @media screen and (min-width: 990px){
    font-size: 16px;
  }
  font-size: 12px;
}
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}

.theme-color-border{
  border:1px solid var(--theme-color-bg) !important;
}
.theme-color{
	color: var(--theme-color) !important
}
.theme-color-bg{
	background-color: var(--theme-color-bg) !important;
}
.them-color-font-bg{
	background-color: var(--theme-font-color-bg) !important;
}
.theme_tips{
	color: var(--theme_tips) !important
}
.theme_tips_bg{
	background-color: var(--theme_tips_bg) !important
}
p{margin:0}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}







</style>
